import empty from "../../assets/icons/empty.svg";
import styles from "./Table.module.scss";
interface Props {
  emptyMessage: string;
}

const NoRowsMessage: React.FC<Props> = ({ emptyMessage }) => {
  return (
    <>
      <div className={styles.emptyMessage}>
        <div>
          <img src={empty} alt="empty" />
        </div>
        <div>
          <p>{emptyMessage}</p>
        </div>
      </div>
    </>
  );
};

export default NoRowsMessage;
